import React from 'react'
import styled from 'styled-components'
import Row from 'react-bootstrap/Row'
import pass from 'assets/images/widgets/priority-pass.png'
import car from 'assets/images/widgets/vip_car_parking.png'
import concert from 'assets/images/widgets/concernt-access.png'
import Col from 'react-bootstrap/Col'
import Separator from 'components/Separator'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { JazeelContext } from '../../../../utils/JazeelContext'

const Wrapper = styled.div`
  padding: 0 2em 2em;
`
const Diamond = styled.div`
  position: relative;
  height: 2.75em;
  width: 2.75em;
  line-height: 12.5em;
  text-align: center;
  margin: 0;
  background: no-repeat center center;
  background-size: 65%;
  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transform: rotateZ(45deg);
    box-shadow: 0 0 26px 0 rgba(0, 0, 0, 0.15);
    border-radius: 7.8px;
  }
  &:after {
    position: absolute;
    top: 0;
    left: 23px;
    content: '';
    transform: rotateX(0) rotateZ(0);
    border-top: 22px solid transparent;
    border-left: 25px solid;
    border-bottom: 25px solid transparent;
    border-radius: 7.5px;
  }
`

const PassDiamond = styled(Diamond)`
  background-image: url(${pass});
  &:after {
    border-left-color: rgba(255, 166, 192, 0.24);
  }
`
const CarDiamond = styled(Diamond)`
  background-image: url(${car});
  &:after {
    border-left-color: rgba(233, 238, 255, 0.6);
  }
`
const Concert = styled(Diamond)`
  background-image: url(${concert});
  &:after {
    border-left-color: transparent;
  }
`
const Title = styled.h2`
  color: #212529;

  font-size: 0.75em;
  font-weight: bold;
  line-height: 0.938em;
`
const Info = styled.p`
  color: #212529;

  font-size: 0.6em;
  line-height: 1.1em;
`
const Count = styled.div`
  border-radius: 50%;
  padding: 0.25em;
  background-color: ${props =>
    props.color ? props.color : 'rgba(92, 200, 71, 0.65)'};
  display: inline-block;
  margin-right: 0.5em;
  @media screen and (max-width: 340px) {
    margin-right: 0.3em;
  }
`
const InnerCount = styled.div`
  border-radius: 50%;
  padding: 0.25em;
  background-color: ${props => (props.color ? props.color : '#5cc847')};
  color: white;

  font-size: 0.5em;
  font-weight: bold;
  line-height: 0.625em;
  text-align: center;
`
const RightIcon = styled(FontAwesomeIcon)`
  vertical-align: -0.3em;
`
export default function Rewards() {
  const { isMobile } = JazeelContext
  return (
    <Wrapper>
      <Row>
        <Col xs={3}>
          <PassDiamond />
        </Col>
        <Col xs={6}>
          <Title>Book Priority Pass</Title>
          <Info>for top-trending mega events on Sharek</Info>
          <Separator
            width={isMobile ? '11.6em' : '100%'}
            color="#EBEBEB"
            marginTop="0.5em"
          />
        </Col>
        <Col xs={3}>
          <Count className="mt-2 mb-2">
            <InnerCount>4</InnerCount>
          </Count>
          <RightIcon icon={faChevronRight} color="#B2B2B2" />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col xs={3}>
          <CarDiamond />
        </Col>
        <Col xs={6}>
          <Title>Book Priority Pass</Title>
          <Info>for top-trending mega events on Sharek</Info>
          <Separator
            width={isMobile ? '11.6em' : '100%'}
            color="#EBEBEB"
            marginTop="0.5em"
          />
        </Col>
        <Col xs={3}>
          <Count className="mt-2 mb-2" color="#B1B1B1">
            <InnerCount color="#777777">0</InnerCount>
          </Count>
          <RightIcon icon={faChevronRight} color="#B2B2B2" />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col xs={3}>
          <Concert />
        </Col>
        <Col xs={6}>
          <Title>Book Priority Pass</Title>
          <Info>for top-trending mega events on Sharek</Info>
        </Col>
        <Col xs={3}>
          <Count className="mt-2 mb-2">
            <InnerCount>4</InnerCount>
          </Count>
          <RightIcon icon={faChevronRight} color="#B2B2B2" />
        </Col>
      </Row>
    </Wrapper>
  )
}
